import { useQuery } from "@tanstack/react-query";
import { getEnvironment } from "@/services/adminApi";

export const environmentKeys = {
  all: ["environment"] as const,
};

export function useEnvironment() {
  return useQuery({
    queryKey: environmentKeys.all,
    queryFn: getEnvironment,
    staleTime: 5 * 60_000,
  });
}
